<template>
  <div class="home">
    <div class="header">
      <div class="topBg"></div>
      <img class="logo" src="@/assets/logo.png" />
      <div class="name">Hit Fortune - Casino Slots</div>
      <div class="head_right">
        <div class="btn_store" @click="onClickS" v-if="false">
          <div class="store"></div>
          <img class="icon_store" src="@/assets/icon_store.png" />
          <div class="text_store">STORE</div>
        </div>
        <a class="btn_download" target="_blank" href="https://app.rayaaustin.com/">
          <div class="download"></div>
          <img class="icon_download" src="@/assets/icon_play_now.png" />
          <div class="text_download">PLAY NOW</div>
        </a>
      </div>
      <div class="banner">
        <img class="banner_bg" src="@/assets/banner_bg.png">
        <div class="banner_content">
          <img class="banner_girl" src="@/assets/banner_girl.png" />
          <img class="banner_boy" src="@/assets/banner_boy.png" />
          <div class="banner_center">
            <div class="most_popular">MOST POPULAR</div>
            <div class="free_bg"></div>
            <div class="free_text">FREE TO PLAY</div>
            <div class="slots">SLOTS</div>
            <a target="_blank" href="https://app.rayaaustin.com/">
              <div class="download_bg"></div>
              <img class="icon_download2" src="@/assets/icon_play_now.png" />
              <div class="download_text">PLAY NOW</div>
            </a>
          </div>
        </div>

      </div>
    </div>
    <div class="main">
      <div class="main_bg"></div>
      <div class="main-content">
        <div class="slot_game_title">A Multitude Of Elegantly Designed Slot Games</div>
        <div class="slot_game_text">Experience a vast collection of free-to-play social casino-style games. Immerse
          yourself in a thrilling gaming atmosphere with diverse casino games. Spin the reels, make your bets, and try
          your luck with our exciting lineup of free titles.</div>
        <img class="g1" src="@/assets/g1.png" />
        <img class="g2" src="@/assets/g2.png" />
        <img class="g3" src="@/assets/g3.png" />
        <img class="g4" src="@/assets/g4.png" />
        <img class="g5" src="@/assets/g5.png" />
        <img class="g6" src="@/assets/g6.png" />
        <img class="g7" src="@/assets/g7.png" />
        <img class="g8" src="@/assets/g8.png" />
        <a href="https://app.rayaaustin.com/" target="_blank">
          <div class="view_more_bg">
            <div class="view_more_text">VIEW MORE</div>
          </div>
        </a>
      </div>
    </div>
    <div class="di_move">
      <div class="feature_display_page">
        <div class="feature_bg"></div>
        <div class="feature_content">
          <img class="icon_blue1" src="@/assets/icon_blue1.png" />
          <div class="title_blue1">A Myriad Of Slot Games Awaits Your Enjoyment</div>
          <div class="text_blue1">Hit Fortune features A myriad of slot games awaits your enjoyment, including popular
            titles like Mega greatest catch, Temple of thunder, and Gold of Sirens. With new games added weekly, you'll
            never run out of exciting options to play.</div>
          <img class="icon_blue2" src="@/assets/icon_blue2.png" />
          <div class="title_blue2">Exceptional User Experience</div>
          <div class="text_blue2">If you're looking for a slots game with an exceptional gaming experience, Hit Fortune
            is the perfect choice. With high-quality visuals, outstanding music and sound effects, it offers an
            immersive journey that transports you into the world of gaming.</div>
          <img class="icon_blue3" src="@/assets/icon_blue3.png" />
          <div class="title_blue3">No Purchase Necessary</div>
          <div class="text_blue3">Hit Fortune is always free to play, with no purchase or payment required You can get
            more free coins by mailing entries, winning comppetitions on collecting your daily free coins.</div>
          <img class="icon_blue4" src="@/assets/icon_blue4.png" />
          <div class="title_blue4">Enjoy VIP Customer Support</div>
          <div class="text_blue4">Looking for a reliable free-to-play slots with top-notch custome support? Hit Fortune
            offers VIP assistance for any questions you may have about our website.</div>
        </div>
      </div>
      <div class="comments_page">
        <div class="comments_page_bg"></div>
        <div class="comments_content">
          <div class="comments_page_title">What Our Players Have to Say</div>
          <div>
            <div class="comment1_bg"></div>
            <div class="comment1_title">,,</div>
            <div class="comment1_text">I really enjoy this slot platform more than the other 20 or so platforms I play
              on.</div>
            <img class="comment1_head" src="@/assets/touxiang1.png" />
            <div class="comment1_name">linus631</div>
          </div>
          <div>
            <div class="comment2_bg"></div>
            <div class="comment2_title">,,</div>
            <div class="comment2_text">This is actually a good good app. I enjoy the V.I.P Bonuses & REWARDS!!!!</div>
            <img class="comment2_head" src="@/assets/touxiang2.png" />
            <div class="comment2_name">Lip-wg1xe</div>
          </div>
          <div>
            <div class="comment3_bg"></div>
            <div class="comment3_title">,,</div>
            <div class="comment3_text">Fun, new, exciting! I really really love this game.</div>
            <img class="comment3_head" src="@/assets/touxiang3.png" />
            <div class="comment3_name">patrickrain1914</div>
          </div>
        </div>
      </div>
    </div>
    <div class="gold_coins">
      <div class="gold_coins_bg"></div>
      <div class="hit_text">HIT FORTUNE'S</div>
      <img class="icon_gold_coins" src="@/assets/gold_coins.png">
      <img class="icon_glod" src="@/assets/icon_glod.png">
      <div class="hit_text2">Looking for non-stop entertainment?</div>
      <div class="hit_text3">Play our <span>Gold Coins</span> games on your desktop deviceand win big with our generous
        jackpots.
        Enjoy free spins and have fun while you play! Try your luck and spin to win with <span>Gold Coins</span> today.
      </div>
      <a href="https://app.rayaaustin.com/" target="_blank">
        <div class="start_btn_bg">
          <div class="start_btn_text">START PLAYING TODAY!</div>
        </div>
      </a>
      <img class="gold_coins_img" src="@/assets/proto.png">
    </div>
    <div class="footer">
      <div class="footer_bg"></div>
      <div class="footer_content">
        <img class="footer_logo" src="@/assets/logo.png">
        <div class="footer_name">Hit Fortune - Casino Slots</div>
        <div class="footer_reserved">Copyright @ 2024 RayaAustin LLC. All rights reserved.</div>
        <div class="footer_introduce">NO PURCHASE IS NECESSARY to play. PROMOTIONS ARE VOID WHERE PROHIBITED BY LAW. For
          detailed rules, see <span class="termsOfUse" @click="onClickTS">Terms of Use</span> & <span class="termsOfUse"
            @click="onClickSwe">Sweepstakes Rules</span>. Hit Fortune is a play-for-fun website intended for amusement
          purposes only. Hit Fortune does not offer "real-money gambling." Hit Fortune Platform is only open to Eligible
          Participants, who are at least eighteen (18) years old or the age of majority in their jurisdiction (whichever
          occurs later) at the time of entry.</div>
        <a class="TermsLink" @click="onClickTS">Terms of Use</a>
        <div class="PrivacyLink" @click="onClickP">Privacy Policy</div>
        <div class="SweepstakesLink" @click="onClickSwe">Sweepstakes Rules</div>
        <div class="ResponsibleLink" @click="onClickRespon">Responsible Social Gameplay</div>
        <div class="CalifoLink" @click="onClickCalifo">California Privacy Notice</div>
      </div>

    </div>
  </div>
</template>

<script>
// import "@/css/home.css"
export default {
  title: "Hit Fortune",
  name: 'HomeView',
  data: function () {
    return {
    }
  },
  props: {
  },
  mounted: function () {
    document.getElementById("body").style.backgroundColor = "#2c1f4d";
    // 动态根据window.scale缩放整个页面
    const handleResize = () => {
      // 计算缩放比例 (当前宽度/设计稿宽度)
      // const scale = window.innerWidth / 1920;
      // console.error("handleResize",window.innerWidth, scale, 1920*scale)
      // 应用缩放
      // document.body.style.zoom = scale;
    };

    window.addEventListener('resize', handleResize);

    // 页面加载完成后立即执行一次
    handleResize();

    // 页面加载完成后立即执行一次检查
    window.onload = function () {
      // 触发resize事件，以便在页面加载时立即进行尺寸检查
      window.dispatchEvent(new Event('resize'));
    };
  },
  beforeDestroy: function () {
    document.getElementById("body").style.backgroundColor = "";
  },
  methods: {
    onClickTS: function () {
      this.$router.push("TermsOfUse")
    },
    onClickP: function () {
      this.$router.push("Privacy")
    },
    onClickS: function () {
      this.$router.push("Shop")
    },
    onClickSwe: function () {
      this.$router.push("Sweepstakes")
    },
    onClickRespon: function () {
      this.$router.push("Responsible")
    },
    onClickCalifo: function () {
      this.$router.push("CaliforniaPrivacyNotice")
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="@/css/home.css" scoped></style>
